import React from 'react';

export default function PageTitle(props) {
    return (
        <h3 className={`title-h3 ${props.margin || 'mb-4'}`}>
            {props.children}
        </h3>
    );
}
